import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/sagivbengiat/cloned_projects/react-elastic-carousel/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Carousel from 'react-elastic-carousel';
import Item from '../components/SimpleItem';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "slidenext--slideprev"
    }}>{`slideNext / slidePrev`}</h1>
    <h4 {...{
      "id": "you-can-trigger-the-slidenext-or-slideprev-methods-via-a-ref-to-the-carousel"
    }}>{`You can trigger the `}<inlineCode parentName="h4">{`slideNext`}</inlineCode>{` or `}<inlineCode parentName="h4">{`slidePrev`}</inlineCode>{` methods via a `}<inlineCode parentName="h4">{`ref`}</inlineCode>{` to the `}<inlineCode parentName="h4">{`Carousel`}</inlineCode>{`:`}</h4>
    <pre><code parentName="pre" {...{}}>{`this.carousel.slideNext()
this.carousel.slidePrev()
`}</code></pre>
    <Playground __position={0} __code={'class App extends React.Component {\n    render() {\n      return (\n        <div>\n          <button onClick={() => this.carousel.slidePrev()}>Prev</button>\n          <button onClick={() => this.carousel.slideNext()}>Next</button>\n          <hr />\n          <Carousel ref={ref => (this.carousel = ref)}>\n            <Item>1</Item>\n            <Item>2</Item>\n            <Item>3</Item>\n            <Item>4</Item>\n            <Item>5</Item>\n            <Item>6</Item>\n          </Carousel>\n        </div>\n      )\n    }\n  }'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Carousel,
      Item,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    {class App extends React.Component {
        render() {
          return <div>
                        <button onClick={() => this.carousel.slidePrev()}>Prev</button>
                        <button onClick={() => this.carousel.slideNext()}>Next</button>
                        <hr />
                        <Carousel ref={ref => this.carousel = ref} mdxType="Carousel">
                            <Item mdxType="Item">1</Item>
                            <Item mdxType="Item">2</Item>
                            <Item mdxType="Item">3</Item>
                            <Item mdxType="Item">4</Item>
                            <Item mdxType="Item">5</Item>
                            <Item mdxType="Item">6</Item>
                        </Carousel>
                    </div>;
        }

      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      